import { gql } from "lib/apolloClient";
import {
  studentFragments,
  supervisorFragments,
  projectUserFragment,
} from "Projects/modules/ProjectFragments";
import { studentsAlertFragment } from "modules/CommonFragments";

export const projectFragments = {
  projectInfoFragment: gql`
    fragment projectInfo on Project {
      id
      students {
        ...userItem
        isArchived
        alertTypes {
          ...alertTypeFields
        }
      }
      supervisors {
        ...supervisorInfo
      }
    }
    ${studentsAlertFragment}
    ${projectUserFragment.basicUser}
    ${supervisorFragments.supervisorInfoFragment}
  `,
  projectGroupStudentProjectInfo: gql`
    fragment projectGroupStudentProjectInfoItem on Project {
      id
      supervisors {
        ...supervisorInfo
      }
      students @include(if: $fetchProjectStudents) {
        ...studentInfo
      }
      fields(filters: $projectFieldFilters) @include(if: $fetchFields) {
        id
        uid
        value
      }
    }
    ${supervisorFragments.supervisorInfoFragmentWithIsArchivedV2}
    ${studentFragments.studentInfoFragment}
  `,
  projectGroupStudentPortfolioInfo: gql`
    fragment projectGroupStudentPortfolioInfoItem on StudentProjectPortfolio {
      id
      staff {
        ...supervisorInfo
      }
    }
    ${supervisorFragments.supervisorInfoFragmentWithIsArchivedV2}
  `,
};

export const projectGroupFragments = {
  projectGroupStudentFragment: gql`
    fragment projectGroupStudent on Student {
      ...userItem
      isArchived
      grades
      courses {
        id
        grades {
          id
          name
        }
      }
    }
    ${projectUserFragment.basicUser}
  `,
  projectGroupStudentsFragmentV2: gql`
    fragment projectGroupStudentsItem on Student {
      ...studentInfo
      registrationCategory
      projects(filters: { projectGroupId: $id, projectArchivalState: ACTIVE })
        @include(if: $fetchProjects) {
        ...projectGroupStudentProjectInfoItem
      }
    }
    ${studentFragments.studentInfoFragment}
    ${projectFragments.projectGroupStudentProjectInfo}
  `,
  projectGroupStudentsFragmentV3: gql`
    fragment projectGroupStudentsItem on Student {
      ...studentInfo
      studentProjectPortfolio(filters: $studentProjectPortfolioFilter) {
        ...projectGroupStudentPortfolioInfoItem
      }
    }
    ${studentFragments.studentInfoFragment}
    ${projectFragments.projectGroupStudentPortfolioInfo}
  `,
};

export const studentProjectPortfolioFragments = {
  studentProjectPortfolioDetailsFragment: gql`
    fragment portfolioStudentAdvisor on StudentProjectPortfolio {
      id
      student {
        ...userItem
      }
      staff {
        ...userItem
      }
    }
    ${projectUserFragment.basicUser}
  `,
};
